/**
 * Central database table registry
 * This ensures consistent table references throughout the application
 * Always use these constants instead of hardcoding table names
 *
 * Pruned 2026-08-15: this registry declared 79 table-name constants; a fresh
 * `rg` sweep found only 6 with any real reference outside this file (3 direct
 * via `DB_TABLES.X`, 3 indirect via the `RESPONDER_TABLES` group that IS
 * imported elsewhere). The other 73 — including `MEDIA`, which a prior audit
 * believed was live — had zero references anywhere in `src/` or `server/`.
 * `USER_TABLES`/`POST_TABLES`/`PLATFORM_TABLES` were dead groups (zero
 * importers) and were removed with the constants they wrapped.
 */

export const DB_TABLES = {
  // Platform Integrations
  FACEBOOK_PAGES: 'facebook_pages',

  // Auto-Responder
  MESSAGE_PROCESSING_LOG: 'message_processing_log',
  ESCALATION_QUEUE: 'escalation_queue',
  RESPONDER_ANALYTICS: 'responder_analytics',

  // Monitoring & System
  WEBHOOK_EVENTS: 'webhook_events',

  // Billing
  USER_SUBSCRIPTIONS: 'user_subscriptions',
} as const;

// Type-safe table names
export type TableName = (typeof DB_TABLES)[keyof typeof DB_TABLES];

// Helper to validate table exists
export function isValidTable(tableName: string): tableName is TableName {
  return Object.values(DB_TABLES).includes(tableName as TableName);
}

// Export specific groups for easier imports
export const RESPONDER_TABLES = {
  MESSAGE_LOG: DB_TABLES.MESSAGE_PROCESSING_LOG,
  ESCALATION: DB_TABLES.ESCALATION_QUEUE,
  ANALYTICS: DB_TABLES.RESPONDER_ANALYTICS,
} as const;
